import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 章見出し（thoughts-ai の ChapterHeading 相当）。
 * params: label（必須, 「第一章」など）、title（任意, 章タイトル）
 * children: 章の中身（段落・引用など）
 */
export const Chapter: React.FC<KnzComponentProps> = ({ node, renderChildren }) => {
  const label = (node.params.label as string) ?? '';
  const title = node.params.title as string | undefined;

  return (
    <Box>
      <Box sx={{ mt: 5, mb: 2 }}>
        <Typography
          sx={{
            fontSize: 11,
            fontFamily: SERIF_FONT,
            letterSpacing: '0.3em',
            color: '#888',
            mb: 0.5,
          }}
        >
          {label}
        </Typography>
        {title && (
          <Typography
            component="h2"
            sx={{
              fontSize: 19,
              fontWeight: 700,
              fontFamily: SERIF_FONT,
              color: '#1A1A1A',
              lineHeight: 1.6,
            }}
          >
            {title}
          </Typography>
        )}
      </Box>
      {renderChildren(node.children)}
    </Box>
  );
};

export default Chapter;
